'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Plane;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Plane(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-truck', className),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.33 6.25c.332 0 .712.082 1.138.246.426.164.777.374 1.055.629.315.273.472.565.472.875 0 .31-.157.602-.472.875-.278.255-.63.465-1.055.629-.426.164-.806.246-1.139.246h-3.165l-2.916 5.031a.437.437 0 0 1-.389.219H5.026a.4.4 0 0 1-.347-.178.414.414 0 0 1-.07-.369L5.97 9.75H3.11l-1.194 1.586a.45.45 0 0 1-.36.164H.443a.412.412 0 0 1-.347-.164.503.503 0 0 1-.097-.383L.89 8 0 5.047a.503.503 0 0 1 .097-.383.412.412 0 0 1 .347-.164h1.111a.45.45 0 0 1 .361.164L3.11 6.25h2.86L4.61 1.547a.414.414 0 0 1 .07-.37A.4.4 0 0 1 5.025 1H6.86c.167 0 .296.073.389.219l2.916 5.031h3.165z' })
  );
}

Plane.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Plane/Plane.js
// module id = 285
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15